// extracted by mini-css-extract-plugin
export var openings = "LandingSection-module--openings--ulvcX";